import React from 'react';
import './SessionHistory.css';

function SessionHistory({ sessions, onSessionSelect }) {
  if (!sessions || sessions.length === 0) {
    return (
      <div className="session-history">
        <h3>Historique des Sessions</h3>
        <p className="empty-sessions">Aucune session de chat pour le moment.</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="session-history">
      <h3>Historique des Sessions</h3>
      <div className="sessions-list">
        {sessions.map((session) => (
          <div
            key={session.id}
            className="session-card"
            onClick={() => onSessionSelect(session.id)}
          >
            <div className="session-date">
              <span className="date-day">{formatDate(session.started_at)}</span>
              <span className="date-time">{formatTime(session.started_at)}</span>
            </div>
            <div className="session-status">
              {session.ended_at ? (
                <span className="status-badge completed">Terminée</span>
              ) : (
                <span className="status-badge active">En cours</span>
              )}
            </div>
            <div className="session-arrow">&rarr;</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SessionHistory;
